import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

const BulkDeleteDocumentsModal = ({ isOpen, onClose, onConfirm, documents, getAssigneeName }) => {
  if (!isOpen || !documents || documents.length === 0) return null;

  return (
    <div className="modal-overlay">
      <div className="delete-modal">
        <div className="modal-header">
          <h2>Confirm Bulk Delete</h2>
          <button className="close-button" onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        <div className="modal-content">
          <p>Are you sure you want to delete {documents.length} document{documents.length > 1 ? 's' : ''}?</p>
          <div className="bulk-document-list">
            {documents.slice(0, 5).map(document => (
              <div key={document.documentId} className="bulk-document-item">
                <div className="bulk-document-name">{document.documentTitle || "Untitled"}</div>
                <div className="bulk-document-assignee">{getAssigneeName(document.assigneeId)}</div>
              </div>
            ))}
            {documents.length > 5 && (
              <div className="bulk-document-more">
                ... and {documents.length - 5} more document{documents.length - 5 > 1 ? 's' : ''}
              </div>
            )}
          </div>
          <p style={{ marginTop: '15px', color: '#e74c3c', fontSize: '14px', fontWeight: '600' }}>
            This action cannot be undone.
          </p>
        </div>
        <div className="modal-actions">
          <button className="cancel-button" onClick={onClose}>Cancel</button>
          <button className="delete-confirm-button" onClick={onConfirm}>Delete All</button>
        </div>
      </div>
    </div>
  );
};

export default BulkDeleteDocumentsModal;
